import { render, staticRenderFns } from "./PracticeCreateLive.vue?vue&type=template&id=3a7749fb&"
import script from "./PracticeCreateLive.vue?vue&type=script&lang=js&"
export * from "./PracticeCreateLive.vue?vue&type=script&lang=js&"
import style0 from "./PracticeCreateLive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports